export enum CourtTypeEnum {
  OUTDOOR = 'OUTDOOR',
  INDOOR = 'INDOOR',
  MALL = 'MALL',
}

export const courtTypeValues: CourtTypeEnum[] = Object.values(CourtTypeEnum) as CourtTypeEnum[];

export enum PrivateCourtTypeEnum {
  PRIVATE_CLUB = 'PRIVATE_CLUB',
  PUBLIC_CLUB = 'PUBLIC_CLUB',
}

export const privateCourtTypeValues: PrivateCourtTypeEnum[] = Object.values(PrivateCourtTypeEnum) as PrivateCourtTypeEnum[];

export interface CourtModel {
  id: number;
  name: string;
  address: string;
  type: CourtTypeEnum;
  distanceKm: number;
  avgRating: number;
  mainImageUrl: string;
  latitude: number;
  longitude: number;
}

export interface CourtBigModel {
  id: number;
  name: string;
  address: string;
  latitude: number;
  longitude: number;
  type: string[];
  matchesPlayed: number;
  numberOfCourts: number;
  bookingRequired: boolean;
  artificialLight: boolean;
  lockerRooms: boolean;
  coachAvailable: boolean
  socialVibe: boolean
  hasCafeOrBar: boolean
  rentalGearAvailable: boolean
  describeThisLocation: string
  parkingAvailability: boolean;
  description: string;
  imagesUrls: string[];
  avgRating: number;
  websiteLink: string;

}

export interface CourtsRequestModel {
  page?: number;
  type?: string;
  bookingRequired?: boolean;
  artificialLight?: boolean;
  lockerRooms?: boolean;
  parkingAvailability?: boolean;
  coachAvailable?: boolean
  socialVibe?: boolean
  hasCafeOrBar?: boolean
  rentalGearAvailable?: boolean
  minRating?: number;
}

export interface CourtRequestModel{
  courtId: number
}

export interface CourtCreateRequestModel{
  name: string;
  address: string;
  latitude: number;
  longitude: number;
  type: string[];
  matchesPlayed: number;
  numberOfCourts: number;
  bookingRequired: boolean;
  artificialLight: boolean;
  lockerRooms: boolean;
  parkingAvailability: boolean;
  description: string;
  imagesUrls: string[];
  describeThisLocation: string;
  socialVibe: boolean
  hasCafeOrBar: boolean
  coachAvailable: boolean
  rentalGearAvailable: boolean
  websiteLink: string
}

export interface CourtUpdateStatusRequestModel{
  draftCourtId: number;
  decision: boolean;
}